import React from 'react';

import _data from '../../data';

export default class Screenshots extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      price: {}
    };
  }

  componentDidMount() {
    /**
     * Your ajax will goes here to get data then call setState
     */

    this.setState({
      price: _data.price
    });
  }

  render() {
    return (
      <React.Fragment>
        <section
          id="screenshots"
          className="screenshots-section ptb-100 gray-light-bg"
        >
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-8">
                <div className="section-heading text-center">
                  <h2>
                    Social Shopping <br /> <span>Por qué juntos compramos mejor</span>
                  </h2>
                  <p className="lead">
                    Frisbee es como tener tu centro comercial favorito en la palma de tu mano.
                    Curamos y personalizamos tu experiencia en nuestra plataforma, 
                    paga fácilmente, sigue tus pedidos en tiempo 
                    real y acumula puntos por tus compras. Todo desde la seguridad y conveniencia de tu smartphone.
                    {" "}
                  </p>
                </div>
              </div>
            </div>
            <div className="screen-slider-content mt-5">
              <div className="screenshot-frame"></div>
              <div className="screen-carousel owl-carousel owl-theme dot-indicator">
                <img src="img/screen-2.png" className="img-fluid" alt="screenshots" />
                <img src="img/screen-1.png" className="img-fluid" alt="screenshots" />
                <img src="img/screen-6.png" className="img-fluid" alt="screenshots" />
                <img src="img/screen-4.png" className="img-fluid" alt="screenshots" />
                <img src="img/screen-8.png" className="img-fluid" alt="screenshots" />
                <img src="img/screen-5.png" className="img-fluid" alt="screenshots" />
                <img src="img/screen-3.png" className="img-fluid" alt="screenshots" />
                <img src="img/screen-7.png" className="img-fluid" alt="screenshots" />
              </div>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}
